/** 包装下拉的 value → 文案 key。同一数字在不同目录含义不同，不能共用一张表。 */

export const SKU_CLASS_KEYS = {
  1: 'publishPkg.skuSingle',
  2: 'publishPkg.skuSame',
  3: 'publishPkg.skuMix',
};

export const PIECE_UNIT_KEYS = {
  1: 'publishPkg.piece',
  2: 'publishPkg.unitPair',
  3: 'publishPkg.unitPack',
};

export const SHEIN_QTY_KEYS = {
  1: 'publishPkg.piece',
  2: 'publishPkg.unitPair',
  3: 'publishPkg.unitSet',
};

export const YES_NO_KEYS = {
  0: 'publishPkg.no',
  1: 'publishPkg.yes',
};

export const SENSITIVE_KEYS = {
  110001: 'publishPkg.sensPure',
  120001: 'publishPkg.sensInner',
  130001: 'publishPkg.sensMagnet',
  140001: 'publishPkg.sensLiquid',
  150001: 'publishPkg.sensPowder',
  160001: 'publishPkg.sensPaste',
  170001: 'publishPkg.sensBlade',
};

export const PACKED_KEYS = {
  1: 'publishPkg.indep',
  0: 'publishPkg.notIndep',
};

export const OUTER_SHAPE_KEYS = {
  1: 'publishPkg.shapeBox',
  2: 'publishPkg.shapeCylinder',
  0: 'publishPkg.shapeOther',
};

export const OUTER_TYPE_KEYS = {
  0: 'publishPkg.typeHard',
  1: 'publishPkg.typeSoftHard',
  2: 'publishPkg.typeSoft',
};

export const SKU_PKG_TYPE_KEYS = {
  3: 'publishPkg.typeHard',
  2: 'publishPkg.typeSoftHard',
  1: 'publishPkg.typeSoft',
  4: 'publishPkg.typeVacuum',
};

export const NET_UNIT_KEYS = {
  1: 'publishPkg.netFlOz',
  2: 'publishPkg.netMl',
  3: 'publishPkg.netGal',
  4: 'publishPkg.netL',
  5: 'publishPkg.netG',
  6: 'publishPkg.netKg',
  7: 'publishPkg.netOz',
  8: 'publishPkg.netLb',
};

export const TITLE_LANG_KEYS = {
  en: 'publishPkg.langEn',
  'zh-cn': 'publishPkg.langZh',
  de: 'publishPkg.langDe',
  fr: 'publishPkg.langFr',
  es: 'publishPkg.langEs',
  it: 'publishPkg.langIt',
  pt: 'publishPkg.langPt',
  ja: 'publishPkg.langJa',
  ko: 'publishPkg.langKo',
};
